import React from "react";

interface Column {
  key: string;
  label: string;
  align?: "left" | "center" | "right";
}

interface DynamicTableProps {
  columns: Column[];
  data: Record<string, any>[];
  className?: string;
}

export default function DynamicTable({
  columns,
  data,
  className = "",
}: DynamicTableProps) {
  return (
    <div
      className={`w-full py-4 ${className}`}
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <div className="bg-white rounded-2xl border border-[var(--border)] overflow-hidden">
        {/* Desktop Table View */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead style={{ backgroundColor: "#F9FAFB" }}>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={column.key}
                    className={`px-6 py-4 font-semibold text-base ${
                      column.align === "center"
                        ? "text-center"
                        : column.align === "right"
                        ? "text-right"
                        : "text-left"
                    } ${index === 0 ? "rounded-tl-2xl" : ""} ${
                      index === columns.length - 1 ? "rounded-tr-2xl" : ""
                    }`}
                    style={{ color: "var(--primary)" }}
                  >
                    {column.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className="border-b border-gray-100 last:border-b-0 hover:bg-gray-50 transition-colors"
                >
                  {columns.map((column, colIndex) => (
                    <td
                      key={column.key}
                      className={`px-6 py-4 text-sm md:text-base ${
                        column.align === "center"
                          ? "text-center"
                          : column.align === "right"
                          ? "text-right"
                          : "text-left"
                      } ${
                        colIndex === 0
                          ? "font-medium text-gray-900"
                          : "text-gray-700"
                      }`}
                    >
                      {row[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Card View */}
        <div className="md:hidden">
          {data.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className="p-4 border-b border-gray-100 last:border-b-0"
            >
              {columns.map((column, colIndex) => (
                <div
                  key={column.key}
                  className={`flex justify-between items-center ${
                    colIndex !== columns.length - 1 ? "mb-3" : ""
                  }`}
                >
                  <span
                    className="font-semibold text-sm"
                    style={{ color: "var(--primary)" }}
                  >
                    {column.label}
                  </span>
                  <span
                    className={`text-sm ${
                      colIndex === 0
                        ? "font-medium text-gray-900"
                        : "text-gray-700"
                    }`}
                  >
                    {row[column.key]}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
